import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a7ec8ad34a2528e0840ead20bf77c891ab from "./generated-bb14892e-62c5-4827-917a-06e980cb0793.json";

import a1e47145b7dbf07484fef9e0f264a6b30b from "./generated-6744dbf9-33a2-4799-ba60-262945ce5a5d.json";

import af3f307c890a8e0285312153215a6ba73b from "./generated-7c589150-c500-4209-b7e9-fc78dd16a81c.json";

import a474221014e28739486a3a4b916375789b from "./generated-0aa7baae-1828-486c-862b-1d68bac611d7.json";

import a8ca429ccacaa24ac3a90c7bf7f77733cb from "./generated-e161b0dc-dc91-49a8-b652-edce5a8523db.json";

import a887dd81d1d7f2cc0f2115364450d0907b from "./generated-60862abb-364b-4113-9fa4-b593f6865ba5.json";

import aa719c885a756cf190d1b591833018437b from "./generated-576e38bb-76f9-49ad-8145-e0ffd712f40f.json";

import abfefa10a20cbc003dca0345f11704285b from "./generated-66b60859-7b4c-417a-9be1-1119b87be062.json";

import ad3fe4b3263c88d56cd678f3b0e0b5988b from "./generated-ce0ca7ab-1553-4440-a643-4bd48a1c3f38.json";

import aa1ec2afea6335a32c29eb0a60028c8e0b from "./generated-417036db-885f-4c5d-bf8c-f8d67f110e95.json";

import a6593fc86e681180aea7dd016e2b25ddbb from "./generated-93cc0384-e4b7-4138-8329-2a59ba854219.json";

import ab3f3dbd51ae6c557e2faeea87e92fb74b from "./generated-801ab20d-3c2a-4eea-932a-5b8ce53b974d.json";

import aade6319d74609c1d906ac485f38e4945b from "./generated-e523b493-6d39-4c35-b77a-ee3b5cd2fbb3.json";

import ad909f311eed88df0dfdd49de6f0ed26cb from "./generated-ca68a17a-e8e3-43ea-b379-2b45c5b5b12f.json";

import abc24eaff6576a5707448c4d7c6a97800b from "./generated-852113cb-a127-4d13-82f1-eb35fcd8e3fa.json";

import aae068e5f48575da3c1890273b1b68c1cb from "./generated-585a5c68-4f32-49be-88f8-1e43a4fd13f5.json";

import a3f90c87033c64e6b9776b35084892271b from "./generated-235acad7-d244-4706-8158-4052b71ce630.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a7ec8ad34a2528e0840ead20bf77c891ab);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1e47145b7dbf07484fef9e0f264a6b30b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af3f307c890a8e0285312153215a6ba73b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a474221014e28739486a3a4b916375789b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8ca429ccacaa24ac3a90c7bf7f77733cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a887dd81d1d7f2cc0f2115364450d0907b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aa719c885a756cf190d1b591833018437b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(abfefa10a20cbc003dca0345f11704285b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ad3fe4b3263c88d56cd678f3b0e0b5988b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aa1ec2afea6335a32c29eb0a60028c8e0b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6593fc86e681180aea7dd016e2b25ddbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ab3f3dbd51ae6c557e2faeea87e92fb74b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ad3fe4b3263c88d56cd678f3b0e0b5988b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aade6319d74609c1d906ac485f38e4945b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad909f311eed88df0dfdd49de6f0ed26cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ad3fe4b3263c88d56cd678f3b0e0b5988b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(abc24eaff6576a5707448c4d7c6a97800b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aae068e5f48575da3c1890273b1b68c1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a3f90c87033c64e6b9776b35084892271b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(abc24eaff6576a5707448c4d7c6a97800b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */